import React from 'react'
import Link from 'next/link'
import type { Route } from 'next'
import { FeatureTriplet, type FeatureTripletItem } from './feature-triplet'
import { Reveal } from './reveal'
import { SectionHead } from './section-head'
import { SiteSection } from './section'
import { trackSiteLinkClicked } from '@/lib/analytics'

export interface PrivacyBandProps {
  eyebrow: string
  titleKey: string
  lead?: string
  items: FeatureTripletItem[]
  link?: { href: Route; label: string }
}

/** 共用隱私帶；首頁多導言，產品頁可在三欄後補政策連結。 */
export function PrivacyBand({ eyebrow, titleKey, lead, items, link }: PrivacyBandProps) {
  return (
    <SiteSection tone="ink" trackingKey="privacy">
      <Reveal>
        <SectionHead tone="ink" eyebrow={eyebrow} titleKey={titleKey} lead={lead} />
      </Reveal>
      <Reveal className="mt-(--gap-xl)">
        <FeatureTriplet variant="ink" items={items} />
      </Reveal>
      {link ? (
        <Reveal as="p" className="mt-(--gap-lg)">
          <Link
            href={link.href}
            onClick={() => trackSiteLinkClicked('privacy', link.href)}
            className="border-b border-background/45 text-background transition-colors hover:border-background focus-visible:rounded-[2px] focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-background"
          >
            {link.label}
          </Link>
        </Reveal>
      ) : null}
    </SiteSection>
  )
}
